export default function Button(props) {
  return (
    <button {...props}>
      <span className="button__layout">{props.children}</span>
    </button>
  );
}
